import type { NextPage } from "next";
import dynamic from "next/dynamic";

import NextSectionAction from "components/next-section-action";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/project-management/main-hero";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));
const FeaturesList = dynamic(() => import("../../components/views/project-management/features-list"));
const IntegrateSeamlessly = dynamic(() => import("../../components/views/project-management/integrate-seamlessly"));

const ProjectManagement: NextPage = () => (
  <Page
    title="Enerflo Solar Software Platform Features | Project Management"
    description="Enerflo integrates with your favorite CRM or you can use Enerflo’s capable Project Management features to power all your project management needs."
  >
    <MainHero />
    <IntegrateSeamlessly />
    <FeaturesList />
    <NextSectionAction
      buttonText="View Customer Engagement"
      url="/features/customer-engagement"
      description="See how to keep your customers engaged through the process"
    />
    <DemoFormSection />
  </Page>
);

export default ProjectManagement;
